import { createEntityAdapter, createSlice, EntityId } from '@reduxjs/toolkit';
import { RootState } from "../index";
import {
  fetchSmsPackage,
  fetchSmsPackages,
  createSmsPackage,
  updateSmsPackage
} from "../../actions/callrecorder/smsPackagesActions";

export interface SmsPackageInterface {
  url: string;

  id: number,

  name: string,
  sms_count: number,
  discount: string,
  active: boolean,

  created_at: string,
  updated_at: string
}

export interface initialInterface {
  error: string | null;
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  count: number;

  editId: EntityId | null;
  editError: string | null;

  newParams: SmsPackageInterface | undefined;
  newError: string | null;
}

const initialState: initialInterface = {
  error: null,
  status: 'idle',
  count: 0,

  editId: null,
  editError: null,

  newParams: undefined,
  newError: null
};

const adaptor = createEntityAdapter<SmsPackageInterface>();

const slice = createSlice({
  name: 'smsPackages',
  initialState: adaptor.getInitialState(initialState),
  reducers: {
    setNewParams: (state, action) => {
      state.newParams = action.payload;
      state.newError  = initialState.newError;
    },
    setNewError: (state, action) => {
      state.newError = action.payload;
    },
    setEditId: (state, action) => {
      state.editId    = action.payload;
      state.editError = initialState.editError;
    },
    setEditError: (state, action) => {
      state.editError = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      // #index
      .addCase(fetchSmsPackages.pending, (state, _action) => {
        state.status = 'loading'
      })
      .addCase(fetchSmsPackages.fulfilled, (state, action) => {
        state.count = action.payload.count;
        state.entities = action.payload.smsPackages;
        state.ids = action.payload.ids;
        state.status = 'succeeded';
      })
      .addCase(fetchSmsPackages.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message || 'Unknown Error';
      })

      // #show
      .addCase(fetchSmsPackage.fulfilled, (state, action) => {
        const pkg = Object.values(action.payload.sms_package)[0];
        state.entities[pkg.id] = pkg;
      })

      // #create
      .addCase(createSmsPackage.fulfilled, (state, action) => {
        const pkg = Object.values(action.payload.sms_package)[0];
        state.entities[pkg.id] = pkg;
      })
      .addCase(createSmsPackage.rejected, (state, action) => {
        const error = Array.isArray(action.payload) ? action.payload[0] : null;
        state.newError = error || action.error.message || 'Unknown Error';
      })

      // #update
      .addCase(updateSmsPackage.fulfilled, (state, action) => {
        const pkg = Object.values(action.payload.sms_package)[0];
        state.entities[pkg.id] = pkg;
      })
      .addCase(updateSmsPackage.rejected, (state, action) => {
        const error = Array.isArray(action.payload) ? action.payload[0] : null;
        state.editError = error || action.error.message || 'Unknown Error';
      })
  }
});

const reducer = slice.reducer;
export default reducer;

export const {
  setEditId,
  setEditError,
  setNewParams,
  setNewError
} = slice.actions;

export const {
  selectById: selectSmsPackageById,
  selectIds: selectSmsPackageIds,
  selectEntities: selectSmsPackageEntities,
}  = adaptor.getSelectors<RootState>(state => state.callrecorder.smsPackages);
